import * as stylex from "@stylexjs/stylex";
import { useRouter } from "next/router";
import { useRTL } from "../hooks";
import { breakpoints, colors } from "../materials/consts.stylex";
const styles = {
    root: {
        kMwMTN: "x1vc0dw",
        kmkexE: "xbkm4cr",
        kmVPX3: "x11kp6bl x1qs66ub",
        kKhh5M: "x1o7uuvo",
        kBCxwx: "x25t5g8",
        kPJHz1: "x784prv",
        k7shQP: "x9v5kkp",
        kZs9gx: "x1v8x7ac",
        kiEn40: "x7s97pk",
        $$css: true
    },
    activeTrue: {
        kSiTet: "x1hc1fzr",
        $$css: true
    },
    activeFalse: {
        kSiTet: "xbyyjgo",
        $$css: true
    },
    notFirstSpacingLtr: {
        koQZXg: "xj3b58b x1fdcg62",
        $$css: true
    },
    notFirstSpacingRtl: {
        km5ZXQ: "x1yf7rl7 x1uj1h4e",
        $$css: true
    }
};
export const LocaleLink = ({ children, locale, isFirst })=>{
    const router = useRouter();
    const isRTL = useRTL();
    const isActive = router.locale === locale;
    return <a {...stylex.props(styles.root, isActive ? styles.activeTrue : styles.activeFalse, !isFirst && (isRTL ? styles.notFirstSpacingRtl : styles.notFirstSpacingLtr))} href={`/${locale}${router.asPath}`}>
      {children}
    </a>;
};
